import { Component, OnInit } from '@angular/core';
import { TransportadorasService } from "./transportadoras.service";
import { TransportadorasModel } from "./transportadoras.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal: any;

@Component({
  selector: 'app-transportadoras',
  templateUrl: './transportadoras.component.html'
})
export class TransportadorasComponent extends Components implements OnInit {

  transportadoras: TransportadorasModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  constructor(
    private transportadorasService: TransportadorasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '24') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    this.carregandoTabela = true;
    this.transportadorasService.getPaginacao(1, this.itensPorPagina)
      .subscribe(data => {
        this.transportadoras = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.transportadoras);
        }
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  delete(transportadora) {
    let transportadoras = this.transportadoras;
    let transportadorasService = this.transportadorasService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarTransportadora') + transportadora.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(transportadoras);
        }

        let index = transportadoras.indexOf(transportadora);
        transportadoras.splice(index, 1);

        transportadorasService.apagar(transportadora.id)
          .subscribe(res => {
            self.transportadoras = transportadoras;
          },
            err => {
              transportadoras.splice(index, 0, transportadora);
              self.transportadoras = transportadoras;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;
    this.transportadorasService.getPaginacao(pagina, this.itensPorPagina)
      .subscribe(data => {
        this.transportadoras = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/transportadoras/transportadoras.component.ts